TYPE_RECOMMENDED_SERIES